import type { Slide } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/http-clients';

// To be used only in presentation related code, for editor use it from @mentimeter/editor-essentials
export const isTypeQuizSlide = (questionType: Question['type'] | undefined) =>
  Boolean(
    questionType &&
      ['quiz', 'quiz_open', 'quiz_leaderboard'].includes(questionType),
  );

export const isCustomScreenshotLoadingSlide = (
  slideType: Slide['staticContent']['type'] | undefined,
) => {
  const matchingSlideTypes: Array<Slide['staticContent']['type']> = [
    'open-ended',
    'pin-on-image',
    'prioritization',
    'ranking',
    'rating',
    'word-cloud',
    'scales',
  ];
  return Boolean(slideType && matchingSlideTypes.includes(slideType));
};
